import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const requestOtp = (email) => api.post("/auth/request-otp", { email }).then((r) => r.data);
export const login = (email, otp) => api.post("/auth/login", { email, otp }).then((r) => r.data);

export const fetchProperties = (city, asset_type) => {
  const params = {};
  if (city && city !== "All") params.city = city;
  if (asset_type && asset_type !== "All") params.asset_type = asset_type;
  return api.get("/properties", { params }).then((r) => r.data.properties);
};

export const invest = (user_id, property_id, amount_gbp) =>
  api.post("/invest", { user_id, property_id, amount_gbp }).then((r) => r.data);

export const fetchPortfolio = (user_id) =>
  api.get(`/portfolio/${user_id}`).then((r) => r.data);

export const withdraw = (user_id, amount_gbp) =>
  api.post("/withdraw", { user_id, amount_gbp }).then((r) => r.data);

export const reinvest = (user_id, property_id, amount_gbp) =>
  api.post("/reinvest", { user_id, property_id, amount_gbp }).then((r) => r.data);

export const fetchSecondaryListings = () =>
  api.get("/secondary-listings").then((r) => r.data.listings);

export const buySecondaryListing = (user_id, listing_id) =>
  api.post(`/secondary-listings/${listing_id}/buy`, { user_id }).then((r) => r.data);
